// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"205":"20da6e598e76b552","308":"2912287e02cd314d","1697":"eaaa23435e5049dd","2372":"7ea404f02862bb8f","7069":"c23f5d036aeb6630"}[chunkId] + ".css";
};